import type { QueryClient } from '@tanstack/react-query';
let privateQueryGeneration = 0;
export const getPrivateQueryGeneration = () => privateQueryGeneration;

/** Keep an in-flight identity check, but synchronously make all private data unavailable. */
export function invalidatePrivateAccountData(queryClient: QueryClient) {
  ++privateQueryGeneration;
  void queryClient.cancelQueries({ predicate: query => query.queryKey[0] !== 'auth' });
  queryClient.removeQueries({ predicate: query => query.queryKey[0] !== 'auth' });
}

/** Stop old requests before removing cached account/workspace data. Keep only the auth observer. */
export async function clearPrivateAccountQueries(queryClient: QueryClient) {
  const generation = ++privateQueryGeneration;
  await queryClient.cancelQueries();
  if (generation === privateQueryGeneration) {
    queryClient.removeQueries({ predicate: query => query.queryKey[0] !== 'auth' });
  }
  return generation;
}
